export const blockIconsFileRuleFolder = (
	<span className='material-symbols-outlined'>rule_folder</span>
);
